export const SIZES = {
  medium: 'medium',
  large: 'large',
};

export const LAYOUTS = {
  oneRow: '1-row',
  twoRow: '2-row',
};
